<template>
  <v-card-actions class="accent pl-2">
    <h-other-payment-methods
      :payment-methods="otherPaymentMethods"
      :disabled="dialogsLocked"
      @select="payBy"
    />
    <v-spacer />
    <v-btn
      icon
      large
      :disabled="dialogsLocked"
      :loading="printing"
      @click="$emit('print')"
    >
      <v-icon v-text="icons.print" />
    </v-btn>
    <template v-if="! monkeyMode">
      <v-spacer />
      <v-btn
        v-if="showCashPayment"
        icon
        large
        :disabled="disableCashPayment"
        @click="payBy(PaymentMethod.CASH)"
      >
        <v-icon v-text="icons.cash" />
      </v-btn>
      <v-btn
        v-if="showCardPayment"
        icon
        large
        :disabled="disableCardPayment"
        @click="payBy(PaymentMethod.CARD)"
      >
        <v-icon v-text="icons.creditCard" />
      </v-btn>
    </template>
    <h-confirm
      :value="zeroDialog"
      :title="__('zeroPayment')"
      :text="__('zeroPaymentDesc')"
      @yes="pay()"
      @no="zeroDialog = false"
    />
    <h-confirm
      :value="confirmTipDialog"
      :title="__('warning')"
      :text="__('cantPayMoreWithoutCash')"
      @yes="convertChangeAsTipAndPay()"
      @no="confirmTipDialog = false"
    />
    <v-dialog
      v-model="askStrategyDialog"
      max-width="280"
    >
      <v-card light>
        <v-card-title
          class="grey lighten-4 primary--text"
          v-text="__('giveChange')"
        />
        <v-list>
          <v-list-item @click="pay()">
            <v-list-item-icon>
              <v-icon v-text="icons.cash" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="__('inCash')" />
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="convertChangeAsTipAndPay()">
            <v-list-item-icon>
              <v-icon v-text="icons.tip" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="__('asTip')" />
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="grey darken-1"
            v-text="__('cancel')"
            @click="askStrategyDialog = false"
          />
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card-actions>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import ProcessesPayments from '@/Mixins/ProcessesPayments'
  import UsesIcons from '@/Mixins/UsesIcons'
  import PaymentMethod from '@/Models/Static/PaymentMethod'
  import HConfirm from '@/Components/Messages/Confirm'
  import HOtherPaymentMethods from './OtherPaymentMethods'

  export default {
    mixins: [
      I18n,
      ProcessesPayments,
      UsesIcons,
    ],

    components: {
      HConfirm,
      HOtherPaymentMethods,
    },

    props: {
      printing: {
        required: true,
        type: Boolean,
      },
    },
  }
</script>
